export default "__VITE_ASSET__e0e18ddb__"